import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { DropdownOption } from '../../components/UI/multi-select-dropdown/MultiSelectDropdown'
import type { RootState } from '../store'

interface TrainingMatrixState {
  showManageViewModal: boolean
  showSaveViewModal: boolean
  hasInTrainingStatus: boolean
  highlightedColumns: Array<string>
  highlightedRows: Array<string>
  hashKey?: string
  selectedView?: DropdownOption
}

const initialState: TrainingMatrixState = {
  showManageViewModal: false,
  showSaveViewModal: false,
  hasInTrainingStatus: false,
  highlightedColumns: [],
  highlightedRows: []
}

const trainingMatrixSlice = createSlice({
  name: 'trainingMatrix',
  initialState,
  reducers: {
    setShowManageViewModal(state, action: PayloadAction<boolean>) {
      state.showManageViewModal = action.payload
    },
    setShowSaveViewModal(state, action: PayloadAction<boolean>) {
      state.showSaveViewModal = action.payload
    },
    setHasInTrainingStatus(state, action: PayloadAction<boolean>) {
      state.hasInTrainingStatus = action.payload
    },
    setHashKey(state, action: PayloadAction<string | undefined>) {
      state.hashKey = action.payload
    },
    setSelectedView(state, action: PayloadAction<DropdownOption | undefined>) {
      state.selectedView = action.payload
    },
    setHighlightedColumns(state, action: PayloadAction<string>) {
      const index = state.highlightedColumns.indexOf(action.payload)
      if (index !== -1) {
        state.highlightedColumns.splice(index, 1)
      } else {
        state.highlightedColumns.push(action.payload)
      }
    },
    setHighlightedRows(state, action: PayloadAction<string>) {
      const index = state.highlightedRows.indexOf(action.payload)
      if (index !== -1) {
        state.highlightedRows.splice(index, 1)
      } else {
        state.highlightedRows.push(action.payload)
      }
    }
  }
})

export const selectHighlightedRows = (state: RootState) => state.trainingMatrix.highlightedRows

export const trainingMatrixReducer = trainingMatrixSlice.reducer
export const trainingMatrixActions = {
  ...trainingMatrixSlice.actions
}
